export default {"src":"/_next/static/image/public/images/calender_file.7e816e6e4551055ba2b92ccf9a5f793e.svg","height":23,"width":24};